import classNames from "classnames/bind";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BackIcon } from "../../components/Icons/Icons";
import { useStoreContext } from "../../hooks/useStoreContext";
import axiosClient from "../../services/axiosClient";
import { actions } from "../../store";
import ModalDetail from "./ModalDetail";
import TableNotification from "./TableNotification";
import TabBar from "../SmartReport/TabBar";
import { tabar } from "./tarBar";
import styles from "./NotificationDetail.module.css";
import { Pagination, Toast, SelectBox, SelectBoxItem } from "../../components";
import { notificationApi } from "../../services/api/notificationApi";
import axiosClient_v2 from "../../services/axiosClient_v2";

const cx = classNames.bind(styles);
function NotificationDetail() {
  const [notificationData, setNotificationData] = useState([]);
  const [toggleGetNotification, setToggleGetNotification] = useState(false);
  const [number, setNumber] = useState(20);
  const [isShowModal, setIsShowModal] = useState(false);
  const [codeNotificationItem, setCodeNotificationItem] = useState();
  const [detailInfo, setDetailInfo] = useState({});
  const [fillNew, setFillNew] = useState(false);
  const [page, setPage] = useState(1);
  const [tabBar, setTabBar] = useState([]);
  const [status, setStatus] = useState("all")
  const [currentPage, setCurrentPage] = useState(1);
  // eslint-disable-next-line
  const [data, dispatch] = useStoreContext();
  const [tabActive, setTabActive] = useState(0);
  const [code, setCode] = useState();
  const handleChangeTab = (tabIndex, codeTab) => {
    setTabActive(tabIndex);
    setCode(codeTab);
  };
  useEffect(() => {
    const getNotification = async () => {
      const params =
        tabActive !== 0
          ? {
            ai_service_code: code ? code : "",
          }
          : {};
      try {
        const seen = status === "all" ? {} : {
          seen: status
        }
        const res = await axiosClient_v2.get(
          `/notification/get-list-notification/?page=${currentPage}&size=10&type_notification_code=${tabActive === 0 ? "STATUS" : "AI"
          }`,
          {
            params: {
              ...params,
              ...seen
            },
          }
        );
        setNotificationData(res.data);
        setPage(Math.ceil(res.count / 10));
      } catch (error) {

      }
    };
    getNotification();
  }, [toggleGetNotification, currentPage, tabActive, code, status]);
  useEffect(() => {
    if (codeNotificationItem && notificationData.length > 0) {
      notificationData.forEach((item) => {
        if (item.CODE === codeNotificationItem) {
          setDetailInfo(item);
        }
      });
    }
  }, [codeNotificationItem, notificationData]);
  useEffect(() => {
    async function getTabBar() {
      try {
        const res2 = await notificationApi.getAllType();
        const tab = res2.map((item, index) => {
          return {
            tabIndex: index,
            tabName: item.DETAIL,
            // code: item.CODE,
            code: item.AI_SERVICE_CODE,
          };
        });
        setCode(res2[0]?.CODE);
        setTabBar(tab);
      } catch (e) {
        Toast.open("Có lỗi khi tải thông báo", "danger");
      }
    }
    getTabBar();
  }, []);

  const handleScrollNotification = (e) => {
    const scroll =
      e.currentTarget.scrollHeight - e.currentTarget.scrollTop - 0.75 <=
      e.target.clientHeight + 1;
    if (scroll) {
      setNumber(number + 20);
    }
  };

  const handleClickItemNotification = (code) => {
    setCodeNotificationItem(code);
    setIsShowModal(!isShowModal);
  };

  const handleCloseModal = () => {
    setIsShowModal(!isShowModal);
  };

  const handleSetItemNotificationSeen = async (code) => {
    const res = await axiosClient.put(
      `/notification/put-change-notification-seen/?notification_code=${code}`
    );
    setToggleGetNotification(!toggleGetNotification);
    dispatch(actions.reGetNotification());
    setIsShowModal(!isShowModal);
    return res;
  };
  return (
    <>
      <div className={cx("header")}>
        <div id="__notification"></div>
        <div className={cx("button-back")}>
          <h1 className={cx("user-name")}>{"Thông báo"}</h1>
        </div>
      </div>
      <TabBar
        listTabBar={tabBar}
        tabActive={tabActive}
        getTabActive={handleChangeTab}
        setCurrentPage={setCurrentPage}
      />
      <div className={cx("filter")}>
        <label className={cx("label")}>Trạng thái</label>
        <SelectBox
          style={{ paddingTop: 8, width: 280 }}
          type="small"
          onChange={(data) => {
            setStatus(data)
          }}
        >
          <SelectBoxItem label="Tất cả" value="all" />
          <SelectBoxItem label="Chưa đọc" value={0} />
          <SelectBoxItem label="Đã đọc" value={1} />
        </SelectBox>
      </div>
      <div className={cx("content")}>
        <div
          className={cx("content-table")}
          onScroll={handleScrollNotification}
        >
          <TableNotification
            dataNotification={notificationData}
            getCode={(data) => handleClickItemNotification(data)}
            fillNew={fillNew}
          />
        </div>
        {notificationData.length > 0 && (
          <div className={cx("pagination")}>
            <Pagination
              currentPage={currentPage}
              onClick={(data) => setCurrentPage(data)}
              onNext={() => setCurrentPage(currentPage + 1)}
              onPrevious={() => setCurrentPage(currentPage - 1)}
              pages={page}
            />
          </div>
        )}
        {isShowModal && (
          <ModalDetail
            getShowModal={handleCloseModal}
            dataInfo={detailInfo}
            getSeen={(data) => handleSetItemNotificationSeen(data)}
          />
        )}
      </div>
    </>
  );
}

export default NotificationDetail;
